(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/analytics-promotion/assets/javascripts/promoclick.js') >= 0) return;  svs.modules.push('/components/components/analytics-promotion/assets/javascripts/promoclick.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components.analytics = svs.components.analytics || {};
  svs.components.analytics.trackPromoClick = function(evt, cb) {
    var data = {
      event: 'promoClick',
      eventInfo: {
        type: 'Promotion',
        eventAction: 'Click'
      },
      component: {
        componentID: evt.id,
        componentName: evt.name,
        componentPosition: evt.position
      }
    };

    if (evt && evt.opt_label) {
      data.eventInfo.eventName = evt.opt_label;
    }
    dataLayerPush(data);
    window.eddl.eddlPush('promoClick', {
      id: evt.id,
      name: evt.name,
      position: evt.position
    });
    var msg = new svs.core.log.Message(svs.core.log.MessageType.event);
    msg.eventCategory = 'Internal Campaign';
    msg.eventAction = '[' + evt.position + ']';
    msg.eventLabel = evt.id;
    msg.eventValue = 1;
    svs.core.log.track('svs.components.analytics', msg);

    if (typeof cb === 'function') {
      svs.core.log.flush();
      setTimeout(cb, 100); 
    }
  };
})(svs);

 })(window);